import React, { useRef, useState, useEffect } from "react";
import instance from "../../api/api.js";
// import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";

import { FilterMatchMode } from "primereact/api";

// import { TabView, TabPanel } from "primereact/tabview";
// import { useNavigate } from "react-router-dom";
// // import { Help } from "../../utils/index.js";
// import { styleIcone } from "../../shared";
// import { IoMdEye } from "react-icons/io";
import { MdOutlinePayment } from "react-icons/md";
import AllCompomentShared from "../../shared/compoments/AllCompomentShared.jsx";
// import MenuPoint from "../../shared/compoments/MenuPoint.jsx";
import {PaiementDatatable} from "../Paiements/ListerPaiement"
import { useParams } from "react-router-dom";
// const options = [
//   {
//     name: "Voir plus",
//     path: "/Historique_paiement/",
//     icone: <IoMdEye style={styleIcone} />,
//     isIdData: true,
//   },
// ];
function DetailPaymentByFacture() {
       const { id } = useParams();
    const [payments, setPayments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filterPayments, setFilterPayments] = useState([]);
  const [btnVisible, setBtnVisible] = useState("Toutes");
//   const VALUE_BTN = [
//     {
//       value: "en attente",
//     },
//     {
//       value: "Confirmer",
//     },
//     {
//       value: "en cours",
//     },
//     {
//       value: "livrée",
//     },
//     {
//       value: "en attente d'annulation",
//     },
//     {
//       value: "annulée",
//     },
//   ];
  const handleFilterCommande = (value) => {
    console.log("handleFilterCommande", value);
    setPayments(filterPayments.filter((item) => item.statut === value));
    setBtnVisible(value);
  };
  const handleAllPayments = () => {
    setPayments(filterPayments);
    setBtnVisible("Toutes");
  };

  const ITEMSFILTER = [
    "created_at",
    "user.nom",
    "user.phone",
    "total",
    "reference",
  ];
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nom: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    phone: { value: null, matchMode: FilterMatchMode.EQUALS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  const itemsAtExportInExcel = payments.map((obj) => {
    const {
      id,
      user_id,
      commentaire,
      created_at,
      produits,
      updated_at,
      deleted_at,
      user,
      ...rest
    } = obj;
    return rest;
  });
  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(itemsAtExportInExcel);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "files");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });

      module.default.saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  };
  const getListPayments = async () => {
      setIsLoading(true);
      try {
        const response = await instance.get("payments");
        console.log("Payments", response.data.data);
        setPayments(response.data.data.filter(item=>Number(item.facture_id) === Number(id)));
        setFilterPayments(response.data.data.filter(item=>Number(item.facture_id) === Number(id)).sort((a, b) => b.flag - a.flag));
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    };
  useEffect(() => {
    
    getListPayments();
  }, []);
  return (
   <AllCompomentShared
      libelleHeaderComp={"Paiements de la facture"}
      isReturn
      titleStatisticHeaderComp={"Nombre de paiements"}
      nbreTotalStatistiqueComp={payments.length}
      SearchTableIsBtnExcel={true}
      SearchTableIsSearch={true}
      placeholderInputSearch={"Recherche"}
      SearchTableLibelleBtn={"Format excel"}
      globalFilterValue={globalFilterValue}
      onGlobalFilterChange={onGlobalFilterChange}
      SearchTableExportExcel={exportExcel}
      iconeStatistiqueHeader={<MdOutlinePayment fontSize={"2em"}/>}
      isLoading={isLoading}
    >
      <PaiementDatatable
        items={payments}
        isVisibleColumn={true}
        filters={filters}
        ITEMSFILTER={ITEMSFILTER}
      />
    </AllCompomentShared>
  )
}

export default DetailPaymentByFacture
